<div class="card m-b-30 card-wrapper-inner">
  <div class="p-3 font-bold fs-5 ">
    {{title}}
  </div>
  <div class="card-header-">
    <span class="header_label-"><svg xmlns="http://www.w3.org/2000/svg" width="22.431" height="22.432"
      viewBox="0 0 22.431 22.432">
      <g id="Group_6231" data-name="Group 6231" transform="translate(-1584 -1177.784)">
        <path id="Path_17624" data-name="Path 17624"
          d="M311,140.558a11.265,11.265,0,0,1,.38-1.816,9.509,9.509,0,0,1,3.586-4.943c.053-.038.105-.079.161-.113.1-.058.1-.121.04-.215a1.33,1.33,0,0,1,1.2-2.005q3.218.04,6.437,0a1.329,1.329,0,0,1,1.2,2c-.08.124-.029.178.069.242a9.66,9.66,0,0,1,.938.719c.115.1.132.158,0,.269a2.218,2.218,0,0,0-.259,3.168.251.251,0,0,1,0,.387,2.186,2.186,0,0,0,.005,2.9.241.241,0,0,1,.006.37,2.187,2.187,0,0,0,0,2.919.236.236,0,0,1,0,.369,2.028,2.028,0,0,0-.523,1.656c.023.194-.055.269-.233.318a13.827,13.827,0,0,1-2.782.438.6.6,0,0,0-.237.032h-2.848c-.376-.039-.752-.074-1.127-.118a9.019,9.019,0,0,1-3.588-1.1,4.681,4.681,0,0,1-2.023-2.307,6.932,6.932,0,0,1-.4-1.649Zm10.5-1.934a1.464,1.464,0,0,0-.741-1.213.979.979,0,0,1-.536-1.149.642.642,0,0,0,0-.131.927.927,0,0,0-.076-.317.633.633,0,0,0-.608-.352.623.623,0,0,0-.561.476,3.283,3.283,0,0,0-.031.872.354.354,0,0,1-.241.38,1.93,1.93,0,0,0-.379,3.2,2.105,2.105,0,0,0,1.27.464.679.679,0,1,1-.425,1.225.805.805,0,0,1-.289-.59.616.616,0,0,0-.732-.57.65.65,0,0,0-.514.768,1.931,1.931,0,0,0,1.152,1.612.243.243,0,0,1,.154.257,2.048,2.048,0,0,0,.033.566.624.624,0,0,0,1.213,0,1.476,1.476,0,0,0,.032-.5.338.338,0,0,1,.226-.367,1.839,1.839,0,0,0,1.059-1.664,1.87,1.87,0,0,0-.991-1.751,2.358,2.358,0,0,0-.984-.258.654.654,0,0,1-.623-.731.675.675,0,0,1,.666-.628.694.694,0,0,1,.68.666.636.636,0,0,0,.683.641C321.3,139.509,321.523,139.231,321.5,138.624Z"
          transform="translate(1273 1052.955)" fill="#28304e" />
        <path id="Path_17625" data-name="Path 17625"
          d="M406.7-20a2.1,2.1,0,0,1,1.428,1.19c.049.112.14.11.237.109.6,0,1.2,0,1.8,0a.68.68,0,0,1,.708.962c-.3.959-.621,1.915-.925,2.874a.276.276,0,0,1-.309.229q-3.327-.009-6.655,0a.276.276,0,0,1-.311-.227c-.3-.959-.62-1.915-.925-2.874a.68.68,0,0,1,.7-.964c.591,0,1.182,0,1.773,0,.1,0,.2.005.257-.115A2.091,2.091,0,0,1,405.916-20Z"
          transform="translate(1186.277 1197.784)" fill="#28304e" />
        <path id="Path_17626" data-name="Path 17626"
          d="M649.44,222.873a1.013,1.013,0,0,1-1.113.76q-2.912,0-5.823,0a.944.944,0,0,1-.892-.528.969.969,0,0,1,.043-1.02.9.9,0,0,1,.783-.448c2.021-.006,4.043-.01,6.064,0a.967.967,0,0,1,.938.754Z"
          transform="translate(956.991 966.74)" fill="#f60" />
        <path id="Path_17627" data-name="Path 17627"
          d="M649.44,297.873a1.013,1.013,0,0,1-1.113.76q-2.912,0-5.823,0a.944.944,0,0,1-.892-.528.969.969,0,0,1,.043-1.02.9.9,0,0,1,.783-.448c2.021-.006,4.043-.01,6.064,0a.967.967,0,0,1,.938.754Z"
          transform="translate(956.991 895.026)" fill="#f60" />
        <path id="Path_17628" data-name="Path 17628"
          d="M649.44,372.873a1.013,1.013,0,0,1-1.113.76q-2.912,0-5.823,0a.944.944,0,0,1-.892-.528.969.969,0,0,1,.043-1.02.9.9,0,0,1,.783-.448c2.021-.006,4.043-.01,6.064,0a.967.967,0,0,1,.938.754Z"
          transform="translate(956.991 823.313)" fill="#f60" />
        <path id="Path_17629" data-name="Path 17629"
          d="M642.189,448.614a1.013,1.013,0,0,1-.62-1.5.909.909,0,0,1,.808-.481c2.02-.006,4.04-.01,6.06,0a.967.967,0,0,1,.937.754v.482a1.076,1.076,0,0,1-.745.745Z"
          transform="translate(957.057 751.602)" fill="#f60" />
      </g>
    </svg>
  Cost </span>

  @if (calculation?.is_override) {
    <span class="header_label-right">
      <img src="../../../../../../assets/img/sales/proposal-edit/danger-icon.png" width="25"
        alt="danger icon for proposal override values">
    Override </span>
  }

  @if (calculation?.activate_buyout) {
    <span class="header_label-right">
      <img src="../../../../../../assets/img/sales/proposal-edit/danger-icon.png" width="25"
        alt="danger icon for proposal override values">
    Active Buyout </span>
  }
</div>

<!-- Cost Cards Grid -->
<div class="po-summary__section-label">GRAND TOTALS</div>
<div class="po-summary__cost-grid">
  <div class="po-summary__cost-card po-summary__cost-card--material">
    <h4 class="po-summary__card-value">{{ (calculation?.materialCost ? calculation?.materialCost : 0) | currency}}</h4>
    <p class="po-summary__card-label">MATERIAL COST</p>
  </div>
  <div class="po-summary__cost-card po-summary__cost-card--saving">
    <h4 class="po-summary__card-value">
      <mat-icon class="po-summary__trend-icon po-summary__trend-icon--down">trending_down</mat-icon>
      {{(calculation?.costSaving ? calculation?.costSaving : 0) | currency}}
    </h4>
    <p class="po-summary__card-label">COST SAVING</p>
  </div>
  <div class="po-summary__cost-card po-summary__cost-card--shipping">
    <h4 class="po-summary__card-value">
      <mat-icon class="po-summary__truck-icon">local_shipping</mat-icon>
      {{(calculation?.shippingCharges ? calculation?.shippingCharges : 0) | currency}}
    </h4>
    <p class="po-summary__card-label">SHIPPING CHARGES</p>
  </div>
  <div class="po-summary__cost-card po-summary__cost-card--escalation">
    <h4 class="po-summary__card-value">
      <mat-icon class="po-summary__trend-icon po-summary__trend-icon--up">trending_up</mat-icon>
      {{(calculation?.cost_escalation ? calculation?.cost_escalation : 0) | currency}}
    </h4>
    <p class="po-summary__card-label">COST ESCALATION</p>
  </div>
  <div class="po-summary__cost-card po-summary__cost-card--vendor-tax">
    <h4 class="po-summary__card-value">
      {{(calculation?.vendorTax ? calculation?.vendorTax : 0) | currency}}
    </h4>
    <p class="po-summary__card-label">VENDOR TAX</p>
  </div>
  <div class="col-md-12">
    <div class="d-flex m-auto prop-cards bg-orange-">
      <div class="col-5 prop-cards-left">
        <h4 class="info-label total-text">{{(calculation?.subTotalCost ? calculation?.subTotalCost : 0) |
        currency}}</h4>
        <p class="info-label total-text">SUBTOTAL<br> COST</p>
      </div>
      <div class="col-md-2 d-flex">
        <img src="../../../../assets/img/general_icons/arrow_forward.svg" alt="">
      </div>
      <div class="col-5 prop-cards-right">
        <h4 class="info-label total-text">{{(calculation?.totalCost? calculation?.totalCost : 0) |
        currency}}</h4>
        <p class="info-label total-text">TOTAL<br> COST</p>
      </div>
    </div>
  </div>
</div>

<!-- Total Bar -->
<div class="po-summary__total-bar">
  <div class="po-summary__total-section">
    <h4 class="po-summary__total-value">{{(calculation?.subTotalCost ? calculation?.subTotalCost : 0) | currency}}</h4>
    <p class="po-summary__total-label">SUBTOTAL COST</p>
  </div>
  <div class="po-summary__total-arrow">
    <img src="../../../../assets/img/general_icons/arrow_forward.svg" alt="">
  </div>
  <div class="po-summary__total-section">
    <h4 class="po-summary__total-value">{{(calculation?.totalCost? calculation?.totalCost : 0) | currency}}</h4>
    <p class="po-summary__total-label">TOTAL COST</p>
  </div>
</div>
</div>
